import { api_get, api_post, api_put, api_delete, PROYECT } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { creditsUnlockTypes } from "redux/reducers/creditsUnlock/types";

const {
  HANDLE_CREDITS_UNLOCK_INPUTS,
  GET_CREDITS_UNLOCK,
  ADD_CREDITS_UNLOCK,
  CHANGE_STATUS_CREDIT_UNLOCK,
  DELETE_CREDITS_UNLOCK,
  CHECK_CREDIT_UNLOCK_SETTINGS,
  CLEAN_EXISTS,
} = creditsUnlockTypes;

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}/customers/credits-unlock`;

export const handleCreditsUnlockInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_CREDITS_UNLOCK_INPUTS, payload: { key, value } });
};

export const getCreditsUnlockAction = (startDate, endDate, stations) => async dispatch => {
  let stationUrl = "";
  stations.forEach(station => {
    stationUrl = `${stationUrl}&idStation=${station.id}`;
  }); 
  const url = `${mainUrl}/station/?startDate=${startDate}&endDate=${endDate}${stationUrl}`;
  dispatch(startRequestComp('loadingCreditsUnlock'));
  try {
    const data = await api_get(url);
    dispatch({ type: GET_CREDITS_UNLOCK, payload: data });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingCreditsUnlock'));
};

export const checkCreditUnlockSettings = (idAccount, idStation) => async dispatch => {
  const url = `${mainUrl}/check?idAccount=${idAccount}&idStation=${idStation}`;
  dispatch(startRequestComp('loadingModCreditsUnlock'));
  try {
    const response = await api_get(url);
    if (response?.exists) {
      dispatch(setSnackbar("La cuenta seleccionada ya cuenta con crédito aprobado","success"))
      dispatch({ type: CHECK_CREDIT_UNLOCK_SETTINGS, payload: true });
    }
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingModCreditsUnlock'));
}

export const cleanExists = () => async dispatch => {
  dispatch({ type: CLEAN_EXISTS })
}

export const createCreditUnlockAction = (form, action= null) => async dispatch => {
  dispatch(startRequestComp('loadingModCreditsUnlock'));
  try {
    const response = await api_post(mainUrl, form);
    dispatch({ type: ADD_CREDITS_UNLOCK, payload: {...response, colorStatus: "info"} });
    action?.()
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingModCreditsUnlock'));
};

export const changeStatusCreditUnlockAction = (id, form, user, action=null) => async dispatch => {
  const url = `${mainUrl}/${id}/status`;
  dispatch(startRequestComp('loadingModCreditsUnlock'));
  try {
    const response = await api_put(url, form);
    dispatch({ type: CHANGE_STATUS_CREDIT_UNLOCK, 
      payload: {...response, user_a_r: user, colorStatus: response.status_ticket ===  "APROBADO" ?  "success" : "error" } });
    action?.()
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingModCreditsUnlock'));
};

export const deleteCreditUnlockAction = (id, action=null) => async dispatch => {
  const url = `${mainUrl}/${id}`;
  dispatch(startRequestComp('loadingCreditsUnlock'));
  try {
    await api_delete(url);
    dispatch({ type: DELETE_CREDITS_UNLOCK, payload: id });
    action?.()
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingCreditsUnlock'));
};